export const FETCH_SHARE_LINKS_REQUEST = 'FETCH_SHARE_LINKS_REQUEST';
export const FETCH_SHARE_LINKS_SUCCESS = 'FETCH_SHARE_LINKS_SUCCESS';
export const FETCH_SHARE_LINKS_FAILURE = 'FETCH_SHARE_LINKS_FAILURE';

export const REVOKE_LINK_REQUEST = 'REVOKE_LINK_REQUEST';
export const REVOKE_LINK_SUCCESS = 'REVOKE_LINK_SUCCESS';
export const REVOKE_LINK_FAILURE = 'REVOKE_LINK_FAILURE';

export const GENERATE_LINK_REQUEST = 'GENERATE_LINK_REQUEST';
export const GENERATE_LINK_SUCCESS = 'GENERATE_LINK_SUCCESS';
export const GENERATE_LINK_FAILURE = 'GENERATE_LINK_FAILURE';
export const CLEAR_GENERATED_LINK = 'CLEAR_GENERATED_LINK';
